/**
 * 
 * @param file - Object that is going to be converted
 * @param withoutPrefix - to replace 
 */
export async function fileToBase64(file: File | Blob, withoutPrefix?: boolean): Promise<string> {
  return await new Promise((res, rej) => {
    try {
      const reader = new FileReader();
      reader.onloadend = function () {
        let base64data = reader.result as string;
        if (withoutPrefix) {
          base64data = base64data.replace(/^data:.+;base64,/, '');
        }
        res(base64data);
      };
      reader.readAsDataURL(file);
    } catch (error) {
      rej(error);
    }
  });
}
